import { useOutletContext } from 'react-router-dom';

export function useFinanceEmbedded(propEmbedded = false) {
  const outlet = useOutletContext();
  return Boolean(propEmbedded || outlet?.embedded);
}
